
import {Component, Vue, Prop, Emit} from 'vue-property-decorator';

import moment from 'moment';
@Component({})
export default class CourseInfo extends Vue {
    @Prop({default: {course: {}}}) record?: any;

    isFold: boolean = true;
    isShowFold: boolean = false;

    getIsShowFold() {
        this.$nextTick(() => {
            let el = document.querySelector('.class-introduction-fold');
            if ((el as any).scrollHeight > 106) {
                this.isShowFold = true;
            } else {
                this.isShowFold = false;
            }
        });
    }

    switchFold() {
        if (this.isFold) {
            this.isFold = false;
        } else {
            this.isFold = true;
        }
    }

    close() {
        this.$emit('close');
    }

    created() {
        // console.log(this.record);
        this.record.course.publishTime = moment(this.record.course.publishTime).format('YYYY/MM/DD HH:mm:ss');
        this.getIsShowFold();
    }
}
